import { render, staticRenderFns } from "./OwnerInvoiceSettlement.vue?vue&type=template&id=b21431dc&"
import script from "./OwnerInvoiceSettlement.vue?vue&type=script&lang=js&"
export * from "./OwnerInvoiceSettlement.vue?vue&type=script&lang=js&"
import style0 from "./OwnerInvoiceSettlement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports